import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  overflow: hidden;
  min-height: 100vh;
`;

export const ContentWrapper = styled.div`
  margin-top: 0px;
  height: 100%;
  overflow: auto;
`;